/**
 * Created by Pactera on 2017/4/14.
 * 列表
 */
import Routes from 'Routes';
import {
  saveOldLocation,
  getMoreQuerySwitch,
  getAllSwitch,
  getcustomerUrlSwitch,
} from '../../modules/actions';
import { parseLoginUrlParams } from 'Utils';
import { initloginInfo } from '../easyLogin/modules/actions';
import { gspUpgrades, gspNewVersion, isCsairApp } from '@csair/emp-helpers';
import {
  facecheckmorequeryswitch,
  facecheckmorequerychannel,
} from './modules/actions';
import { getScheme } from '../reformProcess/modules/actions';
import TicPopUp from 'TicPopUp';
import { loadStatusCodeMsg } from 'enEXchange';
export default store => ({
  path: Routes.ticket.child.updateDetail.key,
  async onEnter(nextState, replace, callback) {
    loadStatusCodeMsg([
      'queryOrderTickets',
      'moreQuery',
      'cancleChangePayIn',
      'checkOrderTicket',
    ]);
    const { channel } = nextState.location.query;
    await store.dispatch(facecheckmorequerychannel(channel === 'cuss'));
    if (
      channel &&
      channel === 'cuss' &&
      !isCsairApp() &&
      !(
        window.__wxjs_environment && window.__wxjs_environment === 'miniprogram'
      )
    ) {
      try {
        let {
          payload: {
            data: { openlink, wechatAppLinkSwitch },
          },
        } = await store.dispatch(
          getScheme({
            url: window.location.href,
          })
        );
        if (wechatAppLinkSwitch === 'Y') {
          window.location.href = openlink;
        } else {
          TicPopUp(
            '温馨提示',
            '您好，因小程序跳转异常，请前往南航APP扫码办理，谢谢。'
          );
        }
      } catch (error) {
        TicPopUp(
          '温馨提示',
          '您好，因小程序跳转异常，请前往南航APP扫码办理，谢谢。'
        );
      }
      return false;
    }
    if (channel && channel === 'cuss') {
      try {
        const reslut = await store.dispatch(
          getAllSwitch([
            'EXTRA_EMP_MOREQUERY_CUSS_SWITCH',
            // 'EXTRA_EMP_APPEAL_SWITCH',
            // 'EXTRA_EMP_CUSTSERVICE'
          ])
        );
        //  const switchData = await store.dispatch(
        //   getcustomerUrlSwitch()
        // );
        // let cs = 'N', at = 'N', ig = 'N';
        // if (switchData.payload.data.kaiguan && switchData.payload.data.kaiguan.length > 0) {
        //   cs = switchData.payload.data.kaiguan.filter(i => i.business_type === "S")[0].is_open === "1" ? "Y" : 'N'
        //   at = switchData.payload.data.kaiguan.filter(i => i.business_type === "P")[0].is_open === "1" ? "Y" : 'N'
        //   ig = switchData.payload.data.kaiguan.filter(i => i.business_type === "J")[0].is_open === "1" ? "Y" : 'N'
        //   window.sessionStorage.setItem('csSwitch', cs);
        //   window.sessionStorage.setItem('atSwitch', at);
        //   window.sessionStorage.setItem('igSwitch', ig);
        // }
        // window.sessionStorage.setItem(
        //   'csSwitch',
        //   reslut.payload.data.EXTRA_EMP_APPEAL_SWITCH
        // );
        // window.sessionStorage.setItem(
        //   'atSwitch',
        //   reslut.payload.data.EXTRA_EMP_CUSTSERVICE
        // );
        // window.sessionStorage.setItem(
        //   'Switch',
        //   reslut.payload.data.EXTRA_EMP_APPEAL_SWITCH
        // );
        await store.dispatch(
          facecheckmorequeryswitch({
            isOpen: reslut.payload.data.EXTRA_EMP_MOREQUERY_CUSS_SWITCH,
          })
        );
        gointo();
      } catch (error) {
        await store.dispatch(facecheckmorequeryswitch({ isOpen: 'N' }));
        gointo();
      }
    } else {
      try {
        const reslut = await store.dispatch(
          getAllSwitch(['EXTRA_EMP_MOREQUERY_SWITCH'])
        );
        // const switchData = await store.dispatch(
        //   getcustomerUrlSwitch()
        // );
        // let cs = 'N', at = 'N', ig = 'N';
        // if (switchData.payload.data.kaiguan && switchData.payload.data.kaiguan.length > 0) {
        //   cs = switchData.payload.data.kaiguan.filter(i => i.business_type === "S")[0].is_open === "1" ? "Y" : 'N'
        //   at = switchData.payload.data.kaiguan.filter(i => i.business_type === "P")[0].is_open === "1" ? "Y" : 'N'
        //   ig = switchData.payload.data.kaiguan.filter(i => i.business_type === "J")[0].is_open === "1" ? "Y" : 'N'
        //   window.sessionStorage.setItem('csSwitch', cs);
        //   window.sessionStorage.setItem('atSwitch', at);
        //   window.sessionStorage.setItem('igSwitch', ig);
        // }
        await store.dispatch(
          facecheckmorequeryswitch({
            isOpen: reslut.payload.data.EXTRA_EMP_MOREQUERY_SWITCH,
          })
        );
        gointo();
      } catch (error) {
        await store.dispatch(facecheckmorequeryswitch({ isOpen: 'N' }));
        gointo();
      }
    }
    async function gointo() {
      let enterUrl = window.location.href;
      window.sessionStorage.setItem('enterUrl', enterUrl);
      const state = store.getState();
      const {
        location: { query },
      } = nextState;
      console.log('退改列表页地址：', window.location.href);
      if (query.urlParams) {
        const q = parseLoginUrlParams(query.urlParams);
        await store.dispatch(
          initloginInfo({
            easylogin: q.mode === 'easy',
            queryNo: q.account,
            familyName: q.lastName || ' ',
            givenName: q.firstName || ' ',
          })
        );
      }
      window.sessionStorage.removeItem('ticketInfoList');
      window.sessionStorage.removeItem('refundOrderOOReq');
      window.sessionStorage.removeItem('changeOrderOOreq');
      window.sessionStorage.removeItem('changeOrderOO_req');
      window.sessionStorage.removeItem('wrongResaon');
      window.sessionStorage.removeItem('ticketApplication'); // GN: [ID1678500][2024-11-26]
      window.sessionStorage.removeItem('orderChannelId');
      window.sessionStorage.removeItem('orderingSiteCode');
      window.sessionStorage.removeItem('changeTap');
      window.sessionStorage.removeItem('pageButtonName');

      window.$sensors.sensors.track(
        'flight_ticket_refund_and_change_page_view',
        {
          page_name: '机票退改列表页',
          tab_type: '可退改',
          channel_id: query.channel ? query.channel : '',
        }
      );

      gspNewVersion(['机票退改列表页面', '072-0001-23028-12201'], {
        1: '页面曝光一次触发一次',
        2: '国双新版',
        3: isCsairApp() ? 'App' : 'Mobile',
      });
      callback();
    }
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const TicketListContainers = require('./components/UpdateDetail')
          .default;
        cb(null, TicketListContainers);
      },
      'list'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/updateDetail/index.js